import { Paper, styled } from '@material-ui/core';

const PaperOutlined = styled(Paper)(({ theme }) => ({
  boxShadow: theme.shadows[2],
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: 8,
}));

export default PaperOutlined;
